import React, { useState } from "react";
import { createClient } from "@supabase/supabase-js";
import "./StartFreeTrial.css"; // Optional: your form styling

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

function StartFreeTrial() {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    password: "",
    clinic_name: "",
    agree: false,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
  
    if (!form.agree) {
      setMessage("Please agree to the Terms of Service.");
      return;
    }
  
    setLoading(true);
    try {
      const { data, error } = await supabase.auth.signUp({
        email: form.email,
        password: form.password,
        options: {
          data: {
            full_name: form.full_name,
            clinic_name: form.clinic_name,
          },
          emailRedirectTo: "http://localhost:3000/confirm",
        },
      });
  
      if (error) {
        console.error("Supabase signUp error:", error);
  
        if (
          error.message.toLowerCase().includes("user already registered") ||
          error.message.toLowerCase().includes("user already exists")
        ) {
          setMessage("This email is already registered. Please log in instead.");
        } else {
          setMessage(error.message || "Signup failed. Please try again.");
        }
  
        return;
      }
  
      if (data?.user && data.user.confirmed_at) {
        setMessage("This email is already confirmed. Please log in.");
      } else if (data?.user && !data.user.confirmed_at) {
        setMessage("You’ve already signed up but haven’t confirmed yet. Please check your email (or check your spam folder).");
      } else {
        setMessage("✅ Success! Please check your email to confirm your account.");
      }
  
    } catch (err) {
      console.error("Unexpected error:", err);
      setMessage("Unexpected error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="start-page">
      <div className="header">
        <img src="/logo.png" alt="Olumis AI Logo" className="logo" />
        <h1>All-in-One AI Assistant to Unlock Your Aesthetic Clinic’s Full Potential</h1>
      </div>

      <div className="start-trial-container">
        <div className="features-box">
          <h2>Your plan comes with:</h2>
          <ul>
            <li>✅ 7-day free trial (no credit card)</li>
            <li>✅ Full feature access</li>
            <li>✅ Setup support for your AI chatbot</li>
            <li>✅ 24/7 expert guidance</li>
            <li>✅ AI trained on your own clinic materials</li>
            <li>✅ Smart appointment handling</li>
            <li>✅ Client inquiry tracking + CRM</li>
            <li>✅ Monthly AI performance reports</li>
            <li>✅ Conversion tracking (chat to booking)</li>
            <li>✅ Escalation to human staff when needed</li>
          </ul>
        </div>

        <form className="signup-form" onSubmit={handleSubmit}>
          <h2>Start Free Trial</h2>
          <input
            type="text"
            name="full_name"
            placeholder="Full Name"
            value={form.full_name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="clinic_name"
            placeholder="Clinic Name"
            value={form.clinic_name}
            onChange={handleChange}
            required
          />

          <label className="agree-row">
            <input
              type="checkbox"
              name="agree"
              checked={form.agree}
              onChange={handleChange}
            />
            <span>
              I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
            </span>
          </label>

          <button type="submit" disabled={loading}>
            {loading ? "Processing..." : "START FREE"}
          </button>

          {message && <p className="error-message">{message}</p>}

          {message.includes("already been signed up") && (
            <p><a href="/login">Go to Login</a></p>
          )}

          <p>Already have an account? <a href="/login">Login here</a></p>
        </form>
      </div>
    </div>
  );
}

export default StartFreeTrial;

